import { mapGetters } from "vuex";
import language from "@/components/Language";
import downloadManual from "@/components/downloadManual.vue";
import axios from "axios";

export default {
    name: "DashboardView",
    props: ["userInfo"],
    computed: {
        currentRoleDashboardUrl(){
            return this.user.role == 'SuperAdmin' ? '/superAdminDashboard' : this.user.role == 'Depo' ? '/depoDashboard' : this.user.role == 'Branch' ? '/branchDashboard' : this.user.role == 'Company'?'/companyDashboard':''
        },
        ...mapGetters({
            userRole: 'getUserRole',
            sidebarMenu: 'getSidebarMenu',
            getLanguage: 'getLanguage'
        }),
        notificationCount() {
            return this.notifications.length;
        },
    },
    components: {
        downloadManual,
    language
},
    data: () => ({
        dashboard: false,
        dialog: false,
        drawer: false,
        isdownloadManualFormVisible: false,
        dialogSection: false,
        companyName: "",
        user: {
        },
        items: [],
        menuOpenState: {},
        selectedDivIndex: -1,
        notifications: [],
        notificationListVisible: false,
        closeTimer: null,
        isCheckboxChecked: false,
    }),
    async created() {
        await this.$store.dispatch("userData")
        this.getMenu();
        this.getNotifications();
    },
    methods: {
        logout() {
            this.$store.dispatch("logout").then(() => {
                this.$router.push("/userlogin");
            });
        },
        getMenu() {
            let userData = this.$store.getters.getInfo;
            let jsonData = {...JSON.parse( userData)}
            this.user = jsonData;
        },
        showdownloadManualForm() {
            this.dialogSection = true;
            this.isdownloadManualFormVisible = true;
        },
        hidedownloadManualForm() {
            this.dialogSection = false,
                this.isdownloadManualFormVisible = false;
        },
        handleItemClick(item) {
            this.$router.push(item.link);
        },

        getNotifications() {
            let param = {
                companyID: 0,
                branchID: 0,
                depoID: 0,
            }
            axios.post("ReportSettings/OfficeAllNotificationAsync", param).then(response => {
                this.notifications = response.data
            }).catch(response => {
                this.notifications = response.data
            });
        },


        toggleNotificationList() {
            this.notificationListVisible = !this.notificationListVisible;
        },
        startCloseTimer() {
            this.closeTimer = setTimeout(() => {
                this.notificationListVisible = false;
            }, 1000); // Adjust the time (in milliseconds) before the list closes
        },
        cancelCloseTimer() {
            clearTimeout(this.closeTimer);
        },

        markAsRead() {
            let param = {
                companyID: 0,
                branchID: 0,
                depoID: 0,
            }
            axios.post("ReportSettings/OfficeMarkasReadALlAsync", param).then(response => {
                console.log(response)
            }).catch(response => {
                console.log(response)

            });
            this.getNotifications();
        },

        
        handleNotificationClick(notification) {
            let param = {
                companyID: 0,
                branchID: 0,
                depoID: 0,
                IsSpecialUserDepartment: notification.notificationID
            }
            axios.post("ReportSettings/ParticularNotificationSeenAsync", param).then(response => {
                console.log(response)
            }).catch(response => {
                console.log(response)
            });
        },


        handleCheckboxChange() {
            if (this.isCheckboxChecked) {
                this.markAsRead();
            }
        },
       
    },

};
